import {
    Action,
    SET_IS_NAV_FROM_MENU
  } from "../actions/navigationFromMenu";
  
  const initialState = {
    isNavigateToNext: true
};

export default function navigationFromMenu(state = initialState, action: Action){
    switch (action.type) {
        case SET_IS_NAV_FROM_MENU : 
        return {
            ...state,
            isNavigateToNext: action.state,
          };
          default:
            return state;
    }
}

